export const VIEWS = {
  BackgroundRemoval: 'backgroundRemoval',
  ObjectsSelection: 'objectsSelection',
  ImageBackgroundGeneration: 'imageBackgroundGeneration',
};
